export interface MaterialWarehouse {
  warehouseId: string;
  warehouseName: string;
  facilityId: string;
}
